import ReadingResourcesStage from "@/components/course-progress/stages/ReadingResourcesStage";

export default function ReadingResources() {
  return <ReadingResourcesStage mode="student" />;
}
